import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { MENSWEAR_SHOPPING_PREFERENCE, WOMENSWEAR_SHOPPING_PREFERENCE } from '../../../common/constants';
import { useAccountCreationContext } from '../../../common/context/AccountCreationContext';
// import SecondaryButton from '../../buttons/SecondaryButton';
import PrimaryParagraph from '../../texts/PrimaryParagraph';
import PrimaryTitle from '../../texts/PrimaryTitle';
import { AccountCreationViewProps } from '../types';
// import PrimaryText from '../../texts/PrimaryText';
import SelectionButton from '../../buttons/SelectionButton';
import PrimaryTextSmall from '../../texts/PrimaryTextSmall';

const ShoppingPreferenceView: FC<AccountCreationViewProps> = (props) => {
	const { setShoppingPreference } = useAccountCreationContext();
	const { t } = useTranslation();

	const handleNext = (shoppingPreference: string) => {
		setShoppingPreference(shoppingPreference);
		props.handleNextStep?.();
	};

	return (
		<div className={'pop-h-full pop-flex pop-justify-between pop-flex-col pop-px-6 pop-py-10 pop-fadeIn pop-mb-5'}>
			{/*<div>*/}
			<PrimaryTitle className="pop-text-center pop-mb-4">{t('shopping_preference_question')}</PrimaryTitle>
				<div className={'pop-flex pop-flex-col pop-items-center'}>
				<div className="pop-grid pop-grid-cols-2 pop-gap-4 pop-items-center pop-mx-auto">
					<SelectionButton
						className={'pop-font-black pop-text-lg'}
						onClick={() => handleNext(WOMENSWEAR_SHOPPING_PREFERENCE)}
					>
						{t('Womenswear')}
					</SelectionButton>
					<SelectionButton
						className={'pop-font-black pop-text-lg'}
						onClick={() => handleNext(MENSWEAR_SHOPPING_PREFERENCE)}
					>
						{t('Menswear')}
					</SelectionButton>
				</div>
			</div>
				<div className="pop-flex pop-justify-center">
					<div className="pop-w-full pop-max-w-[500px] pop-mx-auto pop-flex pop-flex-col pop-py-4 pop-px-4 pop-rounded-xl pop-border-1 pop-border-popsizePrimary20 pop-bg-popsizeSecondary10 pop-shadow-lg">
						<PrimaryTextSmall className="pop-text-center pop-mb-2 pop-italic">
							{t('shopping_preference_message_question')}
						</PrimaryTextSmall>
						<PrimaryParagraph className="pop-text-center">
							{t('shopping_preference_message')}
						</PrimaryParagraph>
					</div>
				</div>
				{/*</div>*/}
		</div>
	);
};

export default ShoppingPreferenceView;
